import { createFileRoute } from '@tanstack/react-router';
import LiveCallsPage from '@/pages/calls/live/LiveCallsPage';

export interface LiveCallsSearch {
  /** The interaction to open first (ADR-318, H: Listen from a campaign's queue). */
  call?: string;
}

export const Route = createFileRoute('/_authenticated/calls/live')({
  validateSearch: (raw: Record<string, unknown>): LiveCallsSearch => ({
    call: typeof raw.call === 'string' && raw.call ? raw.call : undefined,
  }),
  component: LiveCallsPage,
});
